module.exports = __webpack_public_path__ + "img/config-icon.0ac6d67d.svg";